<template>
  <svg
    t="1656318520850"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1499"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
  >
    <path
      d="M512 951.04a435.2 435.2 0 1 1 435.2-435.2 435.2 435.2 0 0 1-435.2 435.2z m0-819.2a384 384 0 1 0 384 384A384 384 0 0 0 512 132.096z"
      p-id="1500"
      :fill="color"
    ></path>
    <path
      d="M468.992 493.824l-130.048-75.008a20.992 20.992 0 0 0-31.232 18.176v150.016a20.992 20.992 0 0 0 31.232 18.176l130.048-75.008a20.992 20.992 0 0 0 0-36.352zM684.8 493.824l-129.536-75.008a21.248 21.248 0 0 0-31.744 18.432v149.504a21.248 21.248 0 0 0 31.744 18.432l129.536-75.008a20.992 20.992 0 0 0 0-36.352z"
      p-id="1501"
      :fill="color"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "i-video-speed",
  props: {
    size: {
      type:  String|Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>


<style scoped lang="less">
svg{
  transition: all 0.5s;
  path{
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/video_speed.vue